import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state/interface';
import * as selectors from '@shared/state/selectors';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'shared-modal-for-active-order',
    templateUrl: './modal-for-active-order.shared.component.html',
    styleUrls: ['./modal-for-active-order.shared.component.scss'],
})
export class ModalForActiveOrderComponent extends ModalViewComponent implements OnInit {
    public cartLocationName$: Observable<string>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public routeService: Services.RouteService,
        public controllers: Controllers,
        private readonly _store: Store<State.IStateShared>,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.size = 'xsm';

        this.cartLocationName$ = this.controllers.cart.cartLocationFriendlyName$();
    }

    public handleContinueOrder($event: MouseEvent): void {
        this.controllers.cart.handleActiveOrderContinue(this.modalData.id);
    }

    public handleStartNewOrder($event: MouseEvent): void {
        this.controllers.cart.handleActiveOrderStartNew(this.modalData.id, this.modalData.locationNo, this.modalData.params?.orderTypeId);
    }

    public handleNewStoreClick($event: MouseEvent): void {
        this.close();
    }
}
